import type { Messages } from '../de';

export default {
  back: 'More',
  loading: 'Loading …',
  loadError: 'Could not load: {error}',
  title: 'Health',
  titleDesktop: 'Your body, every day',
  kicker: '{days} days recorded · since {date}',
  range: 'Period',
  ranges: { d30: '30 d', d90: '90 d', y1: '1 y', all: 'All' },
  empty: 'No health data yet. It appears here after the first Garmin sync.',
  tiles: 'Key figures',
  ofN: '{a} of {b}',
  goalReached: 'Goal reached',
  below: 'below',
  trainingDay: 'Training day',
  avg7: '7-day average',
  hrv: {
    band: 'Normal range',
    night: 'Night value',
    title: 'Overnight HRV',
    sub: 'Garmin normal range as area · last {count} nights',
    lastNight: 'last night · {text}',
    chartLabel: 'HRV over the last {span} nights with normal range; {below} nights below the range',
    empty: 'No HRV values in this period.',
    span: 'HRV period',
    belowBand: ' nights below the range.',
    noValues: 'No values, no verdict.',
  },
  rhr: {
    day: 'Daily value',
    same: 'unchanged',
    higher: '{n} bpm higher',
    lower: '{n} bpm lower',
    title: 'Resting HR',
    sub: 'lowest value of the day · Garmin',
    last: 'latest',
    chartLabel: 'Resting heart rate in this period, latest {value} beats per minute',
    empty: 'No resting HR in this period.',
    takeaway: 'Last week vs first week of the period: ',
  },
  sleep: {
    deep: 'Deep',
    light: 'Light',
    rem: 'REM',
    awake: 'Awake',
    goalLine: 'Goal 7:30',
    title: 'Sleep, last {count} nights',
    sub: 'stages stacked · goal 7:30 h',
    gaps: ' · gaps = watch not worn',
    overNights: 'over {count} nights',
    chartLabel: 'Stacked sleep stages for the last {nights} nights, average {mean} hours',
    empty: 'No sleep data in this period.',
    goalLegend: 'Goal 7:30 h',
    reachedIn: 'Goal reached on ',
    nights: ' nights.',
  },
  bb: {
    range: '{min} to {max}',
    span: 'Range',
    title: 'Body Battery',
    sub: 'daily range from low to peak',
    chartLabel: 'Body Battery per day as a range, average peak {mean}',
    empty: 'No Body Battery values.',
    noTraining: 'no training',
    takeaway: 'Charged in the morning to ',
  },
  stress: {
    levels: { rest: 'rest', low: 'low', medium: 'medium', high: 'high' },
    avg: 'Avg stress',
    title: 'Stress per day',
    sub: 'daily average 0–100 · Garmin',
    chartLabel: 'Stress per day, average {mean}',
    empty: 'No stress values.',
    over50: '; above 50 on {high} of {count} days.',
  },
  steps: {
    thousand: '{n}k',
    name: 'Steps',
    goal: 'Goal {n}',
    title: 'Steps',
    sub: 'per day · dark = goal reached',
    perDay: 'per day',
    chartLabel: 'Steps per day, goal reached on {reached} of {count} days',
    empty: 'No steps in this period.',
    reachedOn: 'Goal reached on ',
    days: ' days.',
  },
  intensity: {
    name: 'Intensity minutes',
    goal: 'Goal {n}',
    title: 'Intensity minutes per week',
    sub: 'week from Monday · goal {n} min (WHO)',
    chartLabel: 'Intensity minutes per week, goal reached in {reached} of {count} full weeks',
    empty: 'No intensity minutes.',
    reachedIn: 'Goal reached in ',
    weeks: ' full weeks.',
  },
  weight: {
    name: 'Weight',
    summary: 'Weight · last 12 months',
    hide: 'hide',
    show: 'show',
    chartLabel: 'Weight trend with {count} measurements',
    count: '{count} measurements',
    change: ' · {value} kg in this period',
    empty: 'No measurements in the last 12 months.',
  },
  spo2: {
    sub: 'Blood oxygen',
    subDays: { one: 'Blood oxygen · {count} day measured in 12 months', other: 'Blood oxygen · {count} days measured in 12 months' },
    lowest: ' · lowest {value} on {date}',
    none: 'No measurement in the last 12 months. The watch only measures SpO2 when the pulse oximeter is switched on.',
  },
} satisfies Messages['health'];
